<template>
  <div class="coagency-detail">
    <div class="coagency-detail-content">
      <div>
        <div class="left-coagency">
          <div class="coagency-img flex-center">
            <img
              :src="
                coagencyData.deptAvatar == null || coagencyData.deptAvatar == ''
                  ? defaultDeptAvatar
                  : coagencyData.deptAvatar
              "
              alt=""
            />
          </div>
          <el-tooltip
            :content="coagencyData.deptName"
            placement="top"
            v-ak-tooltip-auto-show
          >
            <div class="coagency-title ellipsis-aRow">
              {{ coagencyData.deptName }}
            </div>
          </el-tooltip>

          <div class="coagency-resource">
            <div class="info">
              <span>{{ coagencyData.resourceNum }}</span>
              <span>商品数量</span>
            </div>
            <div class="info">
              <span>{{ coagencyData.authorNum }}</span>
              <span>作者数量</span>
            </div>
          </div>
          <el-divider v-if="coagencyData.instIntro != null"></el-divider>
          <div
            class="coagency-info"
            v-if="
              coagencyData.instIntro != null && coagencyData.instIntro != ''
            "
            @mouseenter="enterShow1"
            @mouseleave="leaveShow1"
          >
            <span class="partIntro"  v-if="!showMore">{{ coagencyData.instIntro }}</span>
            <span class="allIntro" v-if="showMore">{{
              coagencyData.instIntro
            }}</span>
          </div>
        </div>
      </div>
      <div class="right-list">
        <div class="author-list">
          <div class="title theme-title">作者列表</div>
          <div class="author-list-box">
            <img
              class="left-arrow"
              :class="floatHand ? 'floathand' : ''"
              v-if="totalA > 5 && floatHand"
              @click="previousPage"
              src="@/assets/icon/left-arrow.png"
              alt=""
            />
            <div
              class="author-box"
              v-for="(item, index) in authorList"
              :key="index"
              @click="toAuthor(item.authorId)"
            >
              <div class="author-avatar flex-center">
                <img
                  :src="
                    item.authorPortrait == null
                      ? defaultImg
                      : item.authorPortrait
                  "
                  alt=""
                />
              </div>
              <el-tooltip
                :content="item.authorName"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <div class="author-name ellipsis-aRow">
                  {{ item.authorName }}
                </div>
              </el-tooltip>

              <div class="author-info">
                <span>学术领域：</span>
                <el-tooltip
                  :content="item.academicField"
                  placement="top"
                  v-ak-tooltip-auto-show
                >
                  <span class="ellipsis-aRow area">{{
                    item.academicField ? item.academicField : "-"
                  }}</span>
                </el-tooltip>
              </div>
            </div>
            <img
              class="right-arrow"
              v-if="totalA > 5 && floatHand"
              :class="floatHand ? 'floathand1' : ''"
              @click="nextPage"
              src="@/assets/icon/right-arrow.png"
              alt=""
            />
          </div>
          <noData class="noDataA" v-if="totalA == 0"></noData>
        </div>
        <el-divider></el-divider>
        <div class="resource-list">
          <div class="title theme-title">商品列表</div>
          <booklist-box :goodsTypeList="goodsTypeList" :data-list="bookList"></booklist-box>
          <noData v-if="total == 0"></noData>
          <div class="pagination-box" v-show="total > 0">
            <el-pagination
              class="ou-pagination"
              background
              hide-on-single-page
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="queryParams1.pageNum"
              :page-sizes="[10, 20, 30, 40, 50]"
              :page-size="queryParams1.pageSize"
              layout="total, prev, pager, next, sizes, jumper, slot"
              :total="total"
            >
              <el-button @click="getList()" class="ou-page-go">GO</el-button>
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { CoagencyInfo, RlistAuthor, RlistBook } from "@/api/coagency/coagency";
import {teachingAttrList} from '@/api/bookstore/bookstore'
import booklistBox from "@/components/booklistBox.vue";
import noData from "@/components/noData.vue";
export default {
  data() {
    return {
      showMore: false,
      floatHand: true,
      defaultDeptAvatar: require("@/assets/images/inst_default_avatar.png"),
      defaultImg: require("@/assets/images/default-avatar.jpg"),
      deptId: null,
      total: 0,
      totalA: 0,
      //左侧机构数据
      coagencyData: {},
      authorList: [],
      bookList: [],
      //查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 5,
        deptId: null,
      },
      //商品列表查询参数
      queryParams1: {
        pageNum: 1,
        pageSize: 10,
        instId: null,
      },
      goodsTypeList:[]
    };
  },
  components: { booklistBox, noData },
  created() {
    this.deptId = this.$route.query.deptId;
    this.getList();
    teachingAttrList("oc_resource_file").then((res) => {
      console.log(res.data);
      this.goodsTypeList = res.data;
    });
  },
  watch: {
    //监听路由变化
    $route() {
      if (this.$route.query.deptId) {
        this.deptId = this.$route.query.deptId;
        this.getList();
      }
    },
  },
  methods: {
    enterShow1() {
      if (this.coagencyData.instIntro.length > 150) {
        this.showMore = true;
      }
    },
    leaveShow1() {
      this.showMore = false;
    },
    async getList() {
      //左侧机构信息
      await CoagencyInfo(this.deptId).then((res) => {
        this.coagencyData = res.data;
      });
      //右侧作者列表
      this.queryParams.deptId = this.deptId;
      await RlistAuthor(this.queryParams).then((res) => {
        this.authorList = res.rows;
        console.log(this.authorList);
        this.totalA = res.total;
      });
      //右侧商品列表
      this.queryParams1.instId = this.deptId;
      await RlistBook(this.queryParams1).then((res) => {
        this.bookList = res.rows;
        this.total = res.total;
      });
    },
    //跳转作者库详情
    toAuthor(id) {
      this.$router.push({
        path: "/authorLibrary/authorDetail",
        query: { authorId: id },
      });
    },
    enterShow() {
      this.floatHand = true;
    },
    leaveShow() {
      this.floatHand = false;
    },
    // 上一页
    previousPage() {
      this.queryParams.pageNum == 1
        ? this.queryParams.pageNum
        : (this.queryParams.pageNum -= 1);
      this.getList();
    },
    // 下一页
    nextPage() {
      this.queryParams.pageNum += 1;
      this.getList();
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams1.pageSize = val;
      this.getList();
    },
    //当前页面
    handleCurrentChange(val) {
      this.queryParams1.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang='scss'>
.coagency-detail {
  padding-bottom: 40px;
  // background: #f2f2f2;
  .coagency-detail-content {
    width: 1400px;
    min-height: 660px;
    margin: 0 auto;
    display: flex;
    box-sizing: border-box;
    .left-coagency {
      width: 304px;
      // height: 660px;
      min-height: 250px;
      background: #fffefd;
      margin-right: 16px;
      padding-bottom: 20px;
      .coagency-img {
        width: 304px;
        height: 130px;
        background: #ffffff;
        margin-bottom: 20px;
        img {
          box-sizing: border-box;
          padding: 8px 5px;
          max-width: 304px;
          max-height: 130px;
        }
      }
      .coagency-title {
        box-sizing: border-box;
        padding: 0 15px;
        text-align: center;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
      }
      .coagency-resource {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        height: 45px;
        .info {
          display: flex;
          flex-direction: column;
          align-items: center;
          span {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #333333;
          }
          span:first-child {
            color: #2e9adb;
            margin-bottom: 15px;
          }
        }
      }
      .el-divider--horizontal {
        margin: 20px 0;
      }
      .coagency-info {
        width: 304px;
        box-sizing: border-box;
        padding: 0 28px 0 20px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: normal;
        color: #333333;
        line-height: 21px;
        // position: relative;
        // word-break: break-all;
        .partIntro {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 16; /*行数*/
          -webkit-box-orient: vertical;
        }
        .allIntro {
          // position: absolute;
          // left: 0;
          // top: 0;
          // z-index: 999;
          // background: #fffefd;
          // box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
          // border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          box-sizing: border-box;
          padding: 0 28px 10px 20px;
        }
      }
    }
    .right-list {
      width: 1080px;
      min-height: 660px;
      background: #fffefd;
      .author-list {
        .noDataA {
          height: 170px;
        }
        .title {
          margin: 20px 0 30px 30px;
        }
        .author-list-box {
          position: relative;
          display: flex;
          overflow: hidden;
          .left-arrow {
            position: absolute;
            left: 0;
            top: 45px;
            cursor: pointer;
          }
          .right-arrow {
            position: absolute;
            right: 0;
            top: 45px;
            cursor: pointer;
          }
          .floathand {
            animation: translate1 0.5s ease-out 0s;
          }
          @keyframes translate1 {
            0% {
              transform: translateX(-20px);
            }
            100% {
              transform: translateX(0);
            }
          }
          .floathand1 {
            animation: translate2 0.5s ease-out 0s;
          }
          @keyframes translate2 {
            0% {
              transform: translateX(20px);
            }
            100% {
              transform: translateX(0px);
            }
          }
          > img {
            width: 30px;
            height: 61px;
          }
          .author-box:first-of-type {
            margin-left: 40px !important;
          }
          .author-box:last-of-type {
            margin: 0;
          }
          .author-box {
            width: 150px;
            height: 210px;
            margin-right: 63px;
            .author-avatar {
              width: 150px;
              height: 150px;
              margin-bottom: 15px;
              cursor: pointer;
              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.1);
              }
            }
            .author-name {
              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #333333;
              margin-bottom: 10px;
              text-align: center;
              cursor: pointer;
            }
            .author-info {
              line-height: 13px;
              width: 160px;
              display: flex;
              justify-content: center;
              font-size: 13px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #999999;
              text-align: center;
              span:first-child {
                width: 70px;
              }
              .area {
                max-width: 90px;
              }
            }
          }
        }
      }
      .resource-list {
        box-sizing: border-box;
        padding: 0 25px 20px 20px;
        .title {
          margin: 0 0 30px 10px;
        }
        .pagination-box {
          margin: 40px 0 20px;
          text-align: right;
        }
      }
    }
  }
}
.el-carousel__item {
  width: 150px;
  height: 170px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
</style>
